import React from "react";
import { withRouter } from "react-router-dom";
import { openInNewCleanWindow } from "../../logic/Utils";
//import useWindowDimensions from "../../components/WindowDimensions";
import * as BosIdentityServices from "data/BosWebServices/BosIdentityServices";

// Externals
import compose from "recompose/compose";
import { sizes } from '../../logic/media-query';
import cn from "classnames";

// DevExtreme components
import Drawer from 'devextreme-react/drawer';

// Custom components
import Sidebar from "./components/Sidebar/Sidebar";
import TitleToolbar from "./components/Topbar/TitleToolbar";
import MaintasksToolbar from "./components/Topbar/MaintasksToolbar";

// Component styles
import classes from "./Dashboard.module.scss";

// Redux
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import * as appStateActions from "redux/actions/appStateActions";

function Dashboard(props) {
  const { children,
    currentDataSegment,
    currentDataSegmentSession,
    configDataAuthToken,
    showAppTitle,
    showMaintasks,
    showSidebar,
    disableLaunchpad,
    bosUserIsAuthenticated,
    bosUserDisplayName,
    hasOpenTasks
  } = props;

  //const { height: windowHeight, width: windowWidth } = useWindowDimensions();

  const currentDataSegmentId = currentDataSegment.id;
  const hasCurrentDataSegment = currentDataSegmentId ? true : false;
  const showMainTasksToggle = hasCurrentDataSegment;
  const appTitle = currentDataSegment.title || "Canotis BOS WebWorkspace";
  const appImage = currentDataSegment.imageRef || null;
  const locationIsAccount = props.location && (props.location.pathname === "/account");
  const disableLanguageSelector = hasOpenTasks || locationIsAccount;

  console.log("Current AppState ShowAppTitle, ShowMaintasks, DisableLaunchpad:", showAppTitle, showMaintasks, disableLaunchpad);
  console.log("Current GlobalDataSegmentId: " + currentDataSegmentId);
  console.log("Current User:", bosUserDisplayName + " (authenticated: " + bosUserIsAuthenticated + ")");

  document.title = appTitle + " [" + bosUserDisplayName + "]";

  const isMobile = !(sizes()['screen-large']) && !(sizes()['screen-medium']);

  const handleShowSidebar = (show) => {
    props.appStateActions.showSidebar(show);
  };

  const handleShowMaintasks = show => {
    props.appStateActions.showMaintasks(show);
  };

  const handleNavigateTo = (target) => {
    if (!target) return;
    props.history.push(target);
  };

  const handleGotoLaunchpad = async () => {
    let isConfigData = currentDataSegment && currentDataSegment.technicalName === "ConfigData";
    if (isConfigData) {
      handleNavigateTo("/launchpad");
    }
    else {
      let result = await BosIdentityServices.fetchRequestOneTimeToken(configDataAuthToken, "launchpad");
      console.log("Fetching OneTimeToken (for launchpad) result: ", result);
      let url = "tokenLogin/" + result.oneTimeToken;
      openInNewCleanWindow(url);
    }
  };

  function calcAvailableViewportSpace() {
    //TODO: check if still needed
    // let width = windowWidth;
    // if (visibleSidebar) width -= 250; //sidebar
    // let height = windowHeight;
    // if (showAppTitle) height -= 42;  //apptitle
    // if (showMaintasks) height -= 72;  //maintasks
    let width = 0;
    let height = 0;
    return { width, height };
  };

  const renderSidebar = () => {
    return (
      <Sidebar
        disableLaunchpad={disableLaunchpad}
        isAuthenticated={bosUserIsAuthenticated}
        userName={bosUserDisplayName || ""}
        navigateTo={handleNavigateTo}
        history={props.history}
      />
    );
  }

  return (
    <div className={cn(classes.dashboard, "dx-theme-background-color")}>
      {showAppTitle
        ? (
          <React.Fragment>
            <TitleToolbar
              className={classes.layoutHeader}
              isSidebarOpen={showSidebar && bosUserIsAuthenticated}
              onToggleShowSidebar={handleShowSidebar}
              title={appTitle}
              titleImageRef={appImage}
              showMainTasks={showMaintasks && hasCurrentDataSegment}
              showMainTasksToggle={showMainTasksToggle}
              onToggleShowMaintasks={handleShowMaintasks}
              disableLaunchpad={disableLaunchpad}
              isAuthenticated={bosUserIsAuthenticated}
              userName={bosUserDisplayName || ""}
              showDirectAccess={hasCurrentDataSegment}
              currentDataSegment={currentDataSegment}
              currentDataSegmentSessionId={currentDataSegmentSession ? currentDataSegmentSession.id : null}
              navigateTo={handleNavigateTo}
              gotoLaunchpad={handleGotoLaunchpad}
              disableLanguageSelector={disableLanguageSelector}
            />
            <MaintasksToolbar
              className={classes.layoutHeader}
              showMainTasks={showMaintasks && hasCurrentDataSegment}
              currentDataSegment={currentDataSegment}
              currentDataSegmentSessionId={currentDataSegmentSession ? currentDataSegmentSession.id : null}
              navigateTo={handleNavigateTo}
            />
          </React.Fragment>
        )
        : null
      }
      <Drawer
        className={cn(classes.layoutBody, classes.darker)}
        opened={showAppTitle && showSidebar && bosUserIsAuthenticated}
        position={'left'}
        openedStateMode={isMobile ? "overlap" : "shrink"}
        closeOnOutsideClick={isMobile ? () => handleShowSidebar(false) : null}
        revealMode={'expand'}
        render={() => renderSidebar()}
      >
        <main className={classes.content}>
          {React.cloneElement(children, { availableSpace: calcAvailableViewportSpace() })}
        </main>
      </Drawer>
    </div>
  );
}

function mapStateToProps(state, ownProps) {
  return {
    showAppTitle: state.appState.showAppTitle,
    showMaintasks: state.appState.showMaintasks,
    showSidebar: state.appState.showSidebar,
    disableLaunchpad: state.appState.disableLaunchpad,
    bosUserDisplayName: state.bosUser.userDisplayName,
    bosUserIsAuthenticated: state.bosUser.isAuthenticated,
    currentDataSegment: state.dataSegments.currentDataSegment,
    currentDataSegmentSession: state.sessions.openSessions.find(item => item.dataSegmentId === state.dataSegments.currentDataSegment.id && !item.taskId)
      || state.sessions.openSessions.find(item => item.dataSegmentId === state.dataSegments.currentDataSegment.id),
    configDataAuthToken: state.dataSegments.configDataSegment.authToken,
    hasOpenTasks: state.sessions.openSessions.some(item => item.taskId)
  };
}

function mapDispatchToProps(dispatch) {
  return {
    appStateActions: bindActionCreators(appStateActions, dispatch)
  };
}

export default compose(
  withRouter,
  connect(
    mapStateToProps,
    mapDispatchToProps
  )
)(Dashboard);
